import { PATH_DASHBOARD, RESUME_SHELL_PREFIX } from '@/routes/paths';
import { MEMBERS_AREA_TARGET } from '@/utils/membersAreaDelivery';

const AFFILIATE_SEGMENT = '/affiliates/';

const MEMBERS_AREA_TARGET_PATH = {
  [MEMBERS_AREA_TARGET.V1]: (resumePaths, productId) => resumePaths.membersArea(productId),
  [MEMBERS_AREA_TARGET.V2]: (resumePaths, productId) => resumePaths.membersV2(productId),
  [MEMBERS_AREA_TARGET.V3]: (resumePaths, productId) => resumePaths.membersV3(productId),
  [MEMBERS_AREA_TARGET.EXTERNAL]: (resumePaths, productId) =>
    resumePaths.membersExternal(productId),
};

export function getMembersAreaTargetPath(target, productId, resumePaths) {
  if (!productId) return PATH_DASHBOARD.general.products.root;

  const buildPath = MEMBERS_AREA_TARGET_PATH[target];

  return buildPath ? buildPath(resumePaths, productId) : resumePaths.root(productId);
}

/**
 * Para onde mandar quem abriu a página de uma área que o produto não tem: a primeira
 * área disponível, ou o resumo do produto quando não há nenhuma.
 */
export function getMembersAreaFallbackPath(targets = [], productId, resumePaths) {
  if (!productId) return PATH_DASHBOARD.general.products.root;

  return targets.length > 0
    ? getMembersAreaTargetPath(targets[0], productId, resumePaths)
    : resumePaths.root(productId);
}

export function isAffiliateResumeShellPath(pathname = '') {
  return isProductResumeShellPath(pathname) && pathname.includes(AFFILIATE_SEGMENT);
}

export function getResumePathsFromPathname(pathname = '') {
  return pathname.includes(RESUME_SHELL_PREFIX)
    ? PATH_DASHBOARD.general.productsResumeShell
    : PATH_DASHBOARD.general.productsResume;
}

export function isProductResumeShellPath(pathname = '') {
  return pathname.includes(RESUME_SHELL_PREFIX);
}

export function getAffiliationsListPath() {
  const storedOrigin = sessionStorage.getItem('originPath');
  if (storedOrigin?.includes('tab=affiliates')) {
    return storedOrigin;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const flowSuffix = searchParams.get('flow') === 'v2' ? '&flow=v2' : '';

  return `${PATH_DASHBOARD.general.products.root}?tab=affiliates${flowSuffix}`;
}
